module.exports = __webpack_public_path__ + "static/img/img15.af2ff19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img15.png
// module id = NAgZ
// module chunks = 1